import { displayNameById, IFile, transferredFromLabel, User } from "@sp-crm/core";

export function fileAttribution(
    file: Pick<IFile, "createdBy" | "transferBusinessName">,
    users: Record<string, User>,
    productName: string,
): { displayUsername: string; sortableUsername: string } {
    if (file.transferBusinessName) {
        return {
            displayUsername: transferredFromLabel(file.transferBusinessName),
            sortableUsername: file.transferBusinessName.toLocaleLowerCase(),
        };
    }
    const name = displayNameById(file.createdBy, users, productName);
    return { displayUsername: name, sortableUsername: name.toLocaleLowerCase() };
}
